export default __webpack_public_path__ + "static/Wideangle_1.8mm_with_IRcut-b624486df273045665b2987d1dfcb2cf.webp";